const convertShiftTimecheckin=(currentShiftTime, targetTimezoneString,format)=> {
        if (currentShiftTime !== null) {
            const utcMatch = targetTimezoneString.match(/UTC\s?([-+]\d+):(\d+)/);
            if (!utcMatch) {
                throw new Error("Invalid timezone string format");
            }
            const targetHoursOffset = parseInt(utcMatch[1], 10); 
            const targetMinutesOffset = parseInt(utcMatch[2], 10); 
            const targetTotalOffsetMinutes = targetHoursOffset * 60 + targetMinutesOffset;
            const currentOffsetMinutes = 5 * 60 + 30;
            const currentDate = new Date(currentShiftTime);
            const shiftUTC = currentDate.getTime() - currentOffsetMinutes * 60000;
            const targetShiftTime = new Date(shiftUTC + targetTotalOffsetMinutes * 60000);
            const year = targetShiftTime.getFullYear();
            const month = String(targetShiftTime.getMonth() + 1).padStart(2, "0");
            const date = String(targetShiftTime.getDate()).padStart(2, "0");
            const hours = String(targetShiftTime.getHours()).padStart(2, "0");
            const minutes = String(targetShiftTime.getMinutes()).padStart(2, "0");
            const seconds = String(targetShiftTime.getSeconds()).padStart(2, "0");
            const milliseconds = String(targetShiftTime.getMilliseconds()).padStart(3, "0");
    
            if(format == 1){
                const day = targetShiftTime.getDate();
      const month = targetShiftTime.toLocaleString("default", {
        month: "short",
      });
const formattedHours = String(hours % 12 || 12).padStart(2, '0'); 
      const ampm = hours >= 12 ? "PM" : "AM";
      const formattedMinutes = String(minutes).padStart(2, "0");
      const formattedTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
      const formattedDate = `${day} ${month} '${String(year).slice(2)}`; 
      const datedone = `${formattedTime} ,${formattedDate}`;
      return datedone
            }else{
            const formattedTime = `${year}-${month}-${date} ${hours}:${minutes}:${seconds}.${milliseconds}`;
            return formattedTime;
            }
           
        }
    }

      export default convertShiftTimecheckin;
  